(() => {
  const t = (key, values = {}, fallback = key) => window.NLV?.i18n?.t(key, values, fallback) ?? String(fallback).replace(/\{([a-zA-Z_][\w]*)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match);
  'use strict';
  if (window.NLVContactResponses) { window.NLVContactResponses.init(); return; }
  const pendingKey = 'nlv-native-contact-pending:v1';
  const processed = new WeakSet();
  const validId = id => /^(?:CustomBaleForm|WarehouseVisitForm)-[\w-]+$/.test(id || '');
  const readPending = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(pendingKey));
      return validId(value?.id) && Number.isFinite(value.at) && Date.now() - value.at >= 0 && Date.now() - value.at <= 3600000 ? value : null;
    } catch (_) { return null; }
  };
  const focus = response => {
    const details = response.closest('details');
    if (details) details.open = true;
    response.focus({ preventScroll: true });
    response.scrollIntoView({ block: 'center', behavior: 'auto' });
  };
  const init = () => {
    const forms = [...document.querySelectorAll('[data-native-contact-form]')].map(marker => marker.closest('form')).filter(form => form && validId(form.id));
    const responses = forms.flatMap(form => [...form.querySelectorAll('[data-contact-response]')]).filter(response => !processed.has(response));
    if (!responses.length) return;
    responses.forEach(response => { response.hidden = true; processed.add(response); });
    let hash = '';
    try { hash = decodeURIComponent(location.hash.slice(1)); } catch (_) {}
    const pending = readPending();
    // The returned native form anchor takes precedence over a previous pending request.
    const origin = forms.some(form => form.id === hash) ? hash : pending?.id;
    const form = forms.find(candidate => candidate.id === origin);
    const response = form?.querySelector('[data-contact-response="error"]') || form?.querySelector('[data-contact-response="success"]');
    if (response) {
      response.hidden = false;
      if (response.dataset.contactResponse === 'success') {
        const fields = form.querySelector('[data-contact-fields]');
        const targets = fields ? [fields] : [...form.children].filter(child => !child.matches('[data-contact-response]'));
        targets.forEach(target => { target.hidden = true; target.style.display = 'none'; });
      }
      focus(response);
    } else {
      // Shopify can render the same contact result into both forms. Without an
      // origin, acknowledge the actual server result once without naming a request.
      const success = responses.some(item => item.dataset.contactResponse === 'success');
      const notice = document.createElement('div');
      notice.className = 'nlv-booking-response wrap';
      notice.style.margin = '24px auto';
      notice.setAttribute('role', success ? 'status' : 'alert');
      notice.tabIndex = -1;
      notice.dataset.contactNeutralResponse = '';
      notice.textContent = success ? t('contact.sent', {}, "Your message was sent. Our team will respond by email.") : t('contact.retry', { error: responses[0].textContent.trim() }, 'Please review your message and try again. {error}');
      (document.getElementById('MainContent') || document.body).prepend(notice);
      focus(notice);
    }
    // Do not clear a pending marker on ordinary navigation or an intervening
    // CAPTCHA page. Consume it only when Shopify actually rendered a response.
    try { sessionStorage.removeItem(pendingKey); } catch (_) {}
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    // Bubble after form-level mix/calendar validation, so rejected requests do
    // not become pending successes. This marker alone never displays success.
    if (event.defaultPrevented || !validId(form?.id) || !form.querySelector('[data-native-contact-form]') || !form.checkValidity()) return;
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ id: form.id, at: Date.now() })); } catch (_) {}
  });
  window.NLVContactResponses = { init };
  init();
  document.addEventListener('shopify:section:load', init);
})();
